import { Box, Flex, Text } from "@chakra-ui/react";
import TableDeviceActivityLog from "./tableDeviceActivityLog";
import { useTab } from "../../contexts/useTab";
import TableDeviceActivityWarning from "./tableDeviceWarning";

export default function DeviceActivityLog() {
  const { activityTab, setActivityTab } = useTab();

  const tabActivity = [
    {
      title: "Hoạt động",
      content: <TableDeviceActivityLog />,
    },
    {
      title: "Cảnh báo",
      content: <TableDeviceActivityWarning />,
    },
  ];

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Quản lý đăng nhập, chấm công
          </Text>
          <Flex
            justifyContent={{ base: "space-around", xl: "flex-start" }}
            gap={{ base: "24px" }}
          >
            {tabActivity.map((e, index) => {
              return (
                <Flex
                  alignItems={"center"}
                  justifyContent={"center"}
                  key={index}
                  onClick={() => setActivityTab(index)}
                  cursor={"pointer"}
                  padding={"12px 5px 0px 5px"}
                  zIndex={"10"}
                >
                  <Text
                    position={"relative"}
                    paddingBottom={"8px"}
                    _before={{
                      content: '""',
                      position: "absolute",
                      bottom: "-1px",
                      left: 0,
                      width: "100%",
                      height: {
                        base: activityTab === index ? "3px" : "0",
                      },
                      backgroundColor: "var(--color-secondary)",
                    }}
                    fontSize={{
                      base: "16px",
                    }}
                    fontWeight={600}
                    lineHeight={"normal"}
                    fontFamily="var(--font-heading-main)"
                    color={
                      activityTab === index
                        ? "var(--color-secondary)"
                        : "#9D9D9D"
                    }
                    textAlign={"center"}
                    whiteSpace="nowrap"
                  >
                    {e?.title}
                  </Text>
                </Flex>
              );
            })}
          </Flex>
        </Flex>
      </Flex>
      <Box mt={{ base: "23px" }}>{tabActivity[activityTab]?.content}</Box>
    </Box>
  );
}
